export default __webpack_public_path__ + "static/heroSectionBg-bfacd503460ac622132a22839bb04aa5.png";